import Vue from 'vue'
import Router from 'vue-router'
import AuthGuard from '@/router/auth-guard'
import Home from '@/pages/Home'
import Devedor from '@/pages/Devedor'
import HelloWorld from '@/pages/HelloWorld'
import Cobranca from '@/pages/cobranca/Cobranca'
import Agenda from '@/pages/agenda/Agenda'
import Signin from '@/pages/user/Signin'
import Signup from '@/pages/user/Signup'
import Usuarios from "@/pages/user/Usuarios";
import Empresas from "@/pages/user/Empresas";
import BoletoBB from "@/pages/boletosbb/BoletosBB";
import Clientes from "@/pages/clientes/Clientes";
import Devedores from "@/pages/devedores/Devedores";
import Dividas from "@/pages/dividas/Dividas";
import Financeiro from "@/pages/financeiro/Financeiro";
import Recebimento from "@/pages/recebimento/Recebimento";
import Relatorio from "@/pages/relatorios/Relatorio";
import RelDividas from "@/pages/relatorios/Dividas";
import Painel from "@/pages/painel/Painel";
import Fechamento from "@/pages/fechamento/Fechamento";
import Chat from "@/pages/chat/Chat";
import MinhasDividas from "@/pages/minhas-dividas/minhas-dividas";

Vue.use(Router)

export default new Router({
  //mode: "history",
  routes: [
    {
      path: '/home-admin',
      name: 'HelloWorld',
      component: HelloWorld,
      beforeEnter: AuthGuard
    },
    {
      path: '/minhas-dividas',
      name: 'MinhasDividas',
      component: MinhasDividas,
      beforeEnter: AuthGuard
    },
    {
      path: '/funcionario/cobranca',
      name: 'Cobranca',
      component: Cobranca,
      beforeEnter: AuthGuard
    },
    {
      path: '/funcionario/cobranca/:id',
      name: 'CobrancaId',
      component: Cobranca,
      beforeEnter: AuthGuard
    },
    {
      path: '/funcionario/agenda',
      name: 'Agenda',
      component: Agenda,
      beforeEnter: AuthGuard
    },
    {
      path: '/boletosbb',
      name: 'BoletoBB',
      component: BoletoBB,
      beforeEnter: AuthGuard
    },
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: AuthGuard
    },
    {
      path: '/devedor',
      name: 'Devedor',
      component: Devedor,
      beforeEnter: AuthGuard
    },
    {
      path: "/usuarios",
      name: "Usuarios",
      component: Usuarios,
      beforeEnter: AuthGuard
    },
    {
      path: "/empresas",
      name: "Empresas",
      component: Empresas,
      beforeEnter: AuthGuard
    },
    {
      path: "/clientes",
      name: "Clientes",
      component: Clientes,
      beforeEnter: AuthGuard
    },
    {
      path: "/devedores",
      name: "Devedores",
      component: Devedores,
      beforeEnter: AuthGuard
    },
    {
      path: "/dividas",
      name: "Dividas",
      component: Dividas,
      beforeEnter: AuthGuard
    },
    {
      path: "/financeiro",
      name: "Financeiro",
      component: Financeiro,
      beforeEnter: AuthGuard
    },
    {
      path: '/recebimentos/:id',
      name: 'Recebimento',
      component: Recebimento,
      beforeEnter: AuthGuard
    },
    {
      path: '/painel',
      name: 'Painel',
      component: Painel,
      beforeEnter: AuthGuard
    },
    {
      path: '/fechamento',
      name: 'Fechamento',
      component: Fechamento,
      beforeEnter: AuthGuard
    },
    {
      path: '/relatorio',
      name: 'Relatorio',
      component: Relatorio,
      beforeEnter: AuthGuard
    },
    {
      path: '/rel-dividas',
      name: 'RelDividas',
      component: RelDividas,
      beforeEnter: AuthGuard
    },
    {
      path: '/chat/:id/:id2',
      name: 'Chat',
      component: Chat,
      beforeEnter: AuthGuard
    },
    /*{
      path: '/signin',
      name: 'Signin',
      component: Signin
      //beforeEnter: NoAuth
    },*/
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
      //beforeEnter: AuthGuard
    },
    {
      path: '/logout',
      name: 'Logout',
      beforeEnter: AuthGuard
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js